import { MdAddTask, MdAddLink, MdEdit,MdPlayArrow,MdOutlineWatch, MdChecklist,MdOutlinePlaylistRemove, MdOutlinePause, MdDelete, MdFormatListBulletedAdd } from "react-icons/md";

export default function  ToolbarOptionComponent({title, icon, clickAction, size}) {

    const toolbarOptionIcon = (()=>{
        switch(icon){
            case 'AddTask':
                return <MdAddTask title={title}  size={size}/>
            case 'AddBulkTask':
                return <MdFormatListBulletedAdd  title={title}  size={size}/>   
            case 'AddProject':
                return <MdAddTask title={title}  size={size}/>
            case 'AddSubtask':
                return <MdAddTask title={title}  size={size}/>
            case 'AddBulkSubtask':
                return <MdFormatListBulletedAdd  title={title}  size={size}/>   
            case 'AddResource':
                return <MdAddLink title={title}  size={size}/>
            case 'AddWorklog':
                return <MdOutlineWatch title={title} size={size}/>
            case 'Edit':
                return <MdEdit title={title} size={size}/>
            case 'Start':
                return <MdPlayArrow title={title} size={size}/>
            case 'Pause':
                return <MdOutlinePause title={title} size={size}/>
            case 'Finish':
                return <MdChecklist title={title} size={size}/>
            case 'Cancel':
                return <MdOutlinePlaylistRemove title={title} size={size}/>                    
            case 'Delete':
                return <MdDelete title={title} size={size}/>                    
    
            }
    
    })
    return (
        <div className='ml-4'>
            <a href='#' className='cursor-pointer' onClick={clickAction}>{toolbarOptionIcon()}</a>
        </div> 
    )
}